var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"outlined":"","rules":_vm.rules,"label":_vm.$t('configurations.report_interval')},model:{value:(_vm.interval),callback:function ($$v) {_vm.interval=$$v},expression:"interval"}})}
var staticRenderFns = []

export { render, staticRenderFns }